const SecurityBadge = ({ darkMode = true }) => {
  // Theme-based colors
  const textColor = darkMode ? "#6C757D" : "#495057";
  const backgroundColor = darkMode ? "#000" : "#f1f3f5";
  const shieldColor = darkMode ? "#6C757D" : "#868e96";
  const labelColor = darkMode ? "#ffffff" : "#212529";

  return (
    <div
      style={{
        alignSelf: "center",
        display: "flex",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Shield Icon Container */}
      <div
        style={{
          backgroundColor,
          padding: "4px",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "24px",
          marginRight: "2px",
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          style={{ display: "block" }}
        >
          <path
            fill={shieldColor}
            d="M479.07,111.36a16,16,0,0,0-13.15-14.74c-86.5-15.52-122.61-26.74-203.33-63.2a16,16,0,0,0-13.18,0C168.69,69.88,132.58,81.1,46.08,96.62a16,16,0,0,0-13.15,14.74c-3.85,61.11,4.36,118.05,24.43,169.24A349.47,349.47,0,0,0,129,393.11c53.47,56.73,110.24,81.37,121.07,85.73a16,16,0,0,0,12,0c10.83-4.36,67.6-29,121.07-85.73A349.47,349.47,0,0,0,454.64,280.6C474.71,229.41,482.92,172.47,479.07,111.36Zm-131,75.11-110.8,128A16,16,0,0,1,225.86,320h-.66a16,16,0,0,1-11.2-4.57l-49.2-48.2a16,16,0,1,1,22.4-22.86l37,36.29L323.9,165.53a16,16,0,0,1,24.2,20.94Z"
          />
        </svg>
      </div>

      {/* Text */}
      <span style={{ fontSize: "16px", color: textColor, marginRight: "4px" }}>
        Secured by
      </span>
      <span
        style={{
          fontFamily: "Sora",
          fontSize: "16px",
          fontWeight: "500",
          color: labelColor,
          display: "flex",
          alignItems: "center",
        }}
      >
        CASH
        <img
          src="/security%20icon.webp"
          alt="O"
          style={{
            width: "13px",
            height: "13px",
            margin: "0 2px",
            verticalAlign: "middle",
          }}
        />
        VER
      </span>
    </div>
  );
};

export default SecurityBadge;
